import React, { useState, useEffect } from 'react';
import InputSearch from '../components/InputSearch';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { useAddressesStore } from '../features/addresses/state/useAddressesStore';
import usePagination from '../components/Pagination/usePagination';
import Pagination from '../components/Pagination/Pagination';
import Tooltip from '../components/Tooltip';
import ArrowForward from '@mui/icons-material/ArrowForward';
import { useRedirectToAccount } from '../features/user/useRedirectToAccount';
import { Table } from '../components/Table';
import { Container, TableTitle } from '../components';

const LIMIT = 20;

const Addresses = () => {
  const { data, isLoading, error, fetchAddresses, total } = useAddressesStore();
  const [searchValue, setSearchValue] = useState('');
  const { page, limit } = usePagination({ limit: LIMIT });
  const totalPages = Math.ceil(total / limit);
  const { handleSwitchToUserAccount } = useRedirectToAccount();

  useEffect(() => {
    fetchAddresses(page, limit, searchValue);
  }, [page, limit, searchValue]);

  const columns = [
    {
      key: 'actions',
      title: 'Адрес',
      render: (value) => {
        const parts = [value?.address, value?.apartment && `кв ${value.apartment}`, value?.city_name, value?.region_name].filter(Boolean);

        return <div>{parts.length > 0 ? parts.join(', ') : ' - '}</div>;
      },
    },
    {
      key: 'controllers_count',
      title: 'Кол-во устройств',
    },
    {
      key: 'actions',
      title: 'Действия',
      render: (row) => (
        <div className={'text-center flex items-center justify-center'}>
          <Tooltip text="Перейти в ЛК">
            <button
              onClick={() => handleSwitchToUserAccount(row?.user_id)}
              className="p-1 flex items-center justify-center rounded-full border border-orange-500 text-orange-500 hover:bg-orange-500 hover:text-white transition">
              <ArrowForward />
            </button>
          </Tooltip>
        </div>
      ),
    },
  ];

  return (
    <Container>
      <div className={'max-w-7xl mx-auto flex items-center justify-between mb-8 gap-4 flex-wrap'}>
        <TableTitle title={'Адреса'} />
        <InputSearch
          handleSearch={setSearchValue}
          placeholder={'Поиск по адресу...'}
          prefix={<LocationOnIcon className="text-gray-500" />}
          className={'min-w-[270px]'}
          showReset={true}
        />
      </div>
      <Table columns={columns} data={data} loading={isLoading} error={error} rowKey={'address'}>
        {isLoading || error || totalPages === 0 ? null : <Pagination initialLimit={LIMIT} totalPages={totalPages} withLimit={true} />}
      </Table>
    </Container>
  );
};
export default Addresses;
